export default __webpack_public_path__ + "static/media/ads-T20_sm_2.a76ab018.jpg";